import Route from '@ember/routing/route';

export default class EsServicesRoute extends Route {
  // Parent route for services namespace - inherits locale from 'es' route
}




